const pageHeaderTemplate = require('../../title.html.mustache');

module.exports = class PageHeaderView {
  constructor({ el }) {
    this.elementSelector = document.querySelector(el);
  }

  render(pageHeaderTitleHash) {
    if (
      this.elementSelector &&
      pageHeaderTitleHash &&
      pageHeaderTitleHash.headerTitle
    ) {
      const searchQuery = pageHeaderTitleHash.headerTitle.searchQuery;
      if (searchQuery) {
        const searchQuerySelector = this.elementSelector.querySelector(
          '.search-query'
        );
        if (searchQuerySelector !== null) {
          searchQuerySelector.textContent = searchQuery;
        }
      } else {
        this.elementSelector.innerHTML = pageHeaderTemplate.render(
          pageHeaderTitleHash
        );
      }
    }
  }
};
